module.exports = __webpack_public_path__ + "static/lights30-091fc110240d54b79225fe4adcf166bb.jpg";